function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class BidirectionalMap {
    set(a, b) {
        // Clean up any previous state
        // that might be set for these keys.
        // Because this map posits that A<>B
        // are always *explicitly* linked that
        // means linking an existing A or B to anything
        // else negates the previous linking.
        this.deleteA(a);
        this.deleteB(b);
        this.aByB.set(b, a);
        this.bByA.set(a, b);
    }
    getByA(a) {
        return this.bByA.get(a);
    }
    getByB(b) {
        return this.aByB.get(b);
    }
    hasA(a) {
        return this.bByA.has(a);
    }
    hasB(b) {
        return this.aByB.has(b);
    }
    deleteA(a) {
        const b = this.getByA(a);
        if (b) {
            this.aByB.delete(b);
        }
        this.bByA.delete(a);
    }
    deleteB(b) {
        const a = this.getByB(b);
        if (a) {
            this.bByA.delete(a);
        }
        this.aByB.delete(b);
    }
    constructor(){
        _define_property(this, "aByB", new Map());
        _define_property(this, "bByA", new Map());
    }
}

//# sourceMappingURL=BidirectionalMap.js.map